import { FaqStep } from './FaqJourney';

export const buyerSteps: FaqStep[] = [
    {
        title: 'Знайдіть товар',
        description:
            'Скористайтеся каталогом і фільтрами. Порівняйте ціну, стан товару, деталі пропозиції та відгуки про продавця.',
    },
    {
        title: 'Оформіть замовлення',
        description:
            'Додайте пропозиції до кошика й виберіть спосіб доставки. Для поштової доставки перевірте дані отримувача; для самовивозу вони не потрібні.',
    },
    {
        title: 'Узгодьте оплату',
        description:
            'Після підтвердження замовлення узгодьте деталі з продавцем у Telegram. Оплатити можна будь-яким способом, про який ви домовитеся між собою.',
    },
    {
        title: 'Отримайте й оцініть',
        description:
            'Стежте за статусом у «Моїх покупках». Для самовивозу підтвердьте отримання; статус поштової доставки оновлюється за даними перевізника. Після завершення залиште відгук.',
    },
];

export const sellerSteps: FaqStep[] = [
    {
        title: 'Підготуйте профіль',
        description:
            'Підтвердьте електронну пошту, перевірте Telegram-нікнейм, вкажіть місто для самовивозу та оберіть доступні покупцям способи доставки.',
    },
    {
        title: 'Створіть пропозицію',
        description:
            'Оберіть товар, точно опишіть його стан і характеристики, додайте кількість, ціну та фото, якщо вони потрібні.',
    },
    {
        title: 'Опрацюйте замовлення',
        description:
            'У «Моїх продажах» перевірте замовлені товари та їхню кількість. Нове замовлення підтвердьте або відхиліть; зміни можна запропонувати після підтвердження, до відправлення.',
    },
    {
        title: 'Передайте товар',
        description:
            'Після узгодження оплати надійно запакуйте товар, додайте ТТН або позначте особисту передачу. Для самовивозу покупець після цього підтверджує отримання.',
    },
];
